import React from 'react'
import styles from './Style.module.css'

const MemberRateBadge = ({ text, color }) => {
  return (
    <div className={`${styles.badge} ${styles.memberRate}`} style={{ backgroundColor: color }}>{text}</div>
  )
}

export default MemberRateBadge